import React, { useEffect, useMemo, useState } from 'react'
import heroLiving from '../assets/hero-living.png'
import heroKitchen from '../assets/hero-kitchen.png'
import heroBath from '../assets/hero-bath.png'

export const DEFAULT_HERO_SLIDES = [
  { img: heroLiving, alt: 'Luxistt furnished living room — a comfortable short stay' },
  { img: heroKitchen, alt: 'Modern kitchen in a Luxistt apartment' },
  { img: heroBath, alt: 'Clean bathroom in a Luxistt short stay' },
]

/** @param {Array<{ url: string, alt?: string }|null|undefined>|null|undefined} apiSlots — length 3 from API; null entries keep defaults */
export function mergeHeroSlidesFromApi(apiSlots) {
  if (!apiSlots || !Array.isArray(apiSlots)) {
    return DEFAULT_HERO_SLIDES
  }
  return DEFAULT_HERO_SLIDES.map((def, i) => {
    const slot = apiSlots[i]
    if (slot && typeof slot.url === 'string' && slot.url.length > 0) {
      return { img: slot.url, alt: slot.alt || def.alt }
    }
    return def
  })
}

const HeroCarousel = ({ slides = DEFAULT_HERO_SLIDES, autoPlay = true, autoPlayTime = 3000 }) => {
  const list = useMemo(() => (Array.isArray(slides) && slides.length > 0 ? slides : DEFAULT_HERO_SLIDES), [slides])
  const [currentSlide, setCurrentSlide] = useState(0)

  useEffect(() => {
    if (!autoPlay) return undefined
    const timer = setTimeout(() => {
      const newSlideIndex = currentSlide >= list.length - 1 ? 0 : currentSlide + 1
      setCurrentSlide(newSlideIndex)
    }, autoPlayTime)
    return () => clearTimeout(timer)
  }, [currentSlide, autoPlayTime, autoPlay, list.length])

  useEffect(() => {
    setCurrentSlide(0)
  }, [list])

  return (
    <div className="wrapper">
      {list.map((item, index) => (
        <div
          key={`${item.img}-${index}`}
          className="wrapper-slide"
          style={{
            backgroundImage: `url(${item.img})`,
            marginLeft: index === 0 ? `-${currentSlide * 100}%` : undefined,
          }}
          role="img"
          aria-label={item.alt}
        />
      ))}
    </div>
  )
}

export default HeroCarousel